export function update(state, payload) {
    return {...state, ...payload};
}



// WEBPACK FOOTER //
// ./app/reducers/horoscope.js